import {toast} from 'react-toastify'
import {API_BASE_URL} from '../../../utils/contants'
import {setupAxios} from '../../modules/auth'
import axios from 'axios'

export const handleInputChange = (
  event: React.SyntheticEvent,
  setInputField: Function,
  InputField: {
    type: string
    startDate: string
    endDate: string
  }
) => {
  let target = event.target as HTMLInputElement
  setInputField({
    ...InputField,
    [target.name]: target.type === 'checkbox' ? target.checked : target.value,
  })
}
export async function createReports(
  InputField: {
    type: string
    startDate: string
    endDate: string
  },
  setInputField: Function,
  initialState: {
    type: string
    startDate: string
    endDate: string
  },

  validateForm: Function,
  setInputError: Function,
  cancelSubmit: Function
) {
  let {cnt, error} = validateForm(InputField)
  setInputError(error)

  if (cnt === 0) {
    try {
      const {token, tenantId} = setupAxios()

      if (!token) {
        toast.error('Authentication required. Please login again.')
        return
      }

      const queryParams = new URLSearchParams({
        type: InputField.type,
        startDate: InputField.startDate,
        endDate: InputField.endDate,
      })

      console.log('API URL:', API_BASE_URL + `/reports?${queryParams.toString()}`)

      const response = await axios.get(API_BASE_URL + `/reports?${queryParams.toString()}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'X-Tenant-Id': `${tenantId}`,
        },
        responseType: 'blob',
        validateStatus: (status) => status === 200, // Only accept 200 as valid
      })

      if (response.status === 200 && response.data instanceof Blob) {
        // Check if response is actually a blob (file) not JSON error
        if (response.data.type.includes('json')) {
          // It's an error response disguised as blob
          const text = await response.data.text()
          const errorData = JSON.parse(text)
          toast.error(errorData.message || 'Failed to generate report')
          return
        }

        const contentDisposition = response.headers['content-disposition']
        
        // Extract filename from Content-Disposition header
        let filename = `Report_${InputField.type}_${InputField.startDate}_to_${InputField.endDate}.xlsx`
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/)
          if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1].replace(/"/g, '')
          }
        }

        // Create blob with correct MIME type
        const blob = new Blob([response.data], {
          type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        })

        // Create a link element and trigger a download
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = filename
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        
        // Clean up after a short delay
        setTimeout(() => {
          document.body.removeChild(link)
          window.URL.revokeObjectURL(link.href)
        }, 100)
        
        toast.success('Report downloaded successfully!')
        cancelSubmit(setInputField, initialState, setInputError)
      }
    } catch (err: any) {
      console.error('Report generation error:', err)
      
      if (err.response) {
        // Server responded with error status
        const errorData = err.response.data
        
        if (err.response.status === 404) {
          // No data found - show warning instead of error
          const message = errorData?.message || errorData?.data || 
            'No records found for the specified date range. Please try a different date range.'
          toast.warning(message, { autoClose: 5000 })
        } else if (err.response.status === 401) {
          toast.error('Unauthorized. Please login again.')
        } else if (err.response.status === 400) {
          toast.error(errorData?.message || errorData?.data || 'Invalid request parameters.')
        } else {
          toast.error(errorData?.message || errorData?.data || 'Failed to generate report')
        }
      } else if (err.request) {
        // Request made but no response received
        toast.error('Cannot connect to server. Please check if backend is running on port 8000.')
      } else {
        // Error in request setup
        toast.error(`Error: ${err.message || 'Failed to generate report'}`)
      }
    }
  }
}
export const validateForm = (InputField: {type: string; startDate: string; endDate: string}) => {
  let cnt = 0
  const error: any = {}

  if (!InputField.type.trim()) {
    cnt = cnt + 1
    error.type = 'Please select/enter a Module Type.'
  }
  if (!InputField.startDate.trim()) {
    cnt = cnt + 1
    error.startDate = 'Please select/enter a Start Date.'
  } else {
    const selectedDate = new Date(InputField.startDate)
    const currentDate = new Date()

    if (selectedDate > currentDate) {
      cnt = cnt + 1
      error.startDate = 'Start Date must not be greater than the current date.'
    }
  }
  if (!InputField.endDate.trim()) {
    cnt = cnt + 1
    error.endDate = 'Please select/enter an End Date.'
  } else if (new Date(InputField.endDate) < new Date(InputField.startDate)) {
    cnt = cnt + 1
    error.endDate = 'End Date must not be earlier than the Start Date.'
  } else {
    const selectedDate = new Date(InputField.endDate)
    const currentDate = new Date()

    if (selectedDate > currentDate) {
      cnt = cnt + 1
      error.endDate = 'End Date must not be greater than the current date.'
    }
  }
  return {error, cnt}
}

export const cancelSubmit = (
  setInputField: Function,
  InputField: {type: string; startDate: string; endDate: string},
  setInputError: Function
) => {
  setInputField(InputField)
  setInputError('')
}
